import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

// ─────────────────────────────────────────────
// CONSTANTS
// ─────────────────────────────────────────────
const PAGE_W = 595.28;
const MARGIN = 20;
const CONTENT_W = PAGE_W - MARGIN * 2;
const FONT = "courier";

// ─────────────────────────────────────────────
// DRAW HEADER
// ─────────────────────────────────────────────
function drawHeader(doc, y) {
  const cx = PAGE_W / 2;

  // ── Company name ──────────────────────────────────────────────────────────
  doc.setFont(FONT, "bold");
  doc.setFontSize(13);
  const companyLines = doc.splitTextToSize(
    "Chamarajanagar District Co operative Milk Producers Union (CHAMUL),",
    CONTENT_W,
  );
  companyLines.forEach((line) => {
    doc.text(line, cx, y, { align: "center" });
    y += 15;
  });

  // ── Address / GSTIN ───────────────────────────────────────────────────────
  doc.setFont(FONT, "normal");
  doc.setFontSize(9);
  doc.text(
    "Kuderu Village, Santhemarahalli Hobli, Chamarajanagar Dist, Karnataka -571316, Mob: 08226 – 234848",
    cx,
    y,
    { align: "center" },
  );
  y += 12;
  doc.text("GSTIN: 29AACAC2089A1Z1", cx, y, { align: "center" });
  y += 12;

  // ── Invoice label (centered & properly spaced) ─────────────────────
  doc.setLineWidth(1);
  doc.line(MARGIN, y, PAGE_W - MARGIN, y);

  const titleBoxHeight = 22;
  doc.line(MARGIN, y + titleBoxHeight, PAGE_W - MARGIN, y + titleBoxHeight);

  doc.setFont(FONT, "bold");
  doc.setFontSize(12);

  const centerX = MARGIN + CONTENT_W / 2;
  const centerY = y + titleBoxHeight / 2 + 4;

  doc.text("RATE CHART", centerX, centerY, { align: "center" });

  y += titleBoxHeight + 10;

  return y;
}

// ─────────────────────────────────────────────
// MAIN EXPORT
// ─────────────────────────────────────────────
export function generateRateChartPDF(data = [], columns = [], options = {}) {
  // If you want it to download by default or open in new tab.
  // Following invoice_pdf, we will download by default if download=true, otherwise open blob.
  const {
    download = false,
    filename = `Rate_Chart_${Date.now()}.pdf`,
    onStart,
    onFinish,
  } = options;

  if (!data?.length) return;
  onStart?.();

  try {
    const doc = new jsPDF({
      unit: "pt",
      format: "a4",
      orientation: "portrait",
    });
    let y = MARGIN;

    y = drawHeader(doc, y);

    const head = [columns.map((col) => col.title)];
    const body = data.map((row, index) =>
      columns.map((col) => {
        if (col.dataIndex === "sl_no") return String(index + 1);
        const val = row[col.dataIndex];
        return val !== undefined && val !== null ? String(val) : "";
      }),
    );

    autoTable(doc, {
      head,
      body,
      startY: y,
      margin: { left: MARGIN, right: MARGIN },
      tableWidth: CONTENT_W,
      styles: {
        font: FONT,
        fontSize: 9,
        cellPadding: 3,
        lineColor: [0, 0, 0],
        lineWidth: 0.3,
        textColor: [0, 0, 0],
      },
      headStyles: {
        fillColor: [220, 220, 220],
        textColor: [0, 0, 0],
        fontStyle: "bold",
        halign: "center",
        valign: "middle",
        minCellHeight: 20,
      },
      columnStyles: columns.reduce((acc, col, idx) => {
        acc[idx] = { halign: col.align || "center" };
        return acc;
      }, {}),
      didParseCell(cellData) {
        if (cellData.section === "body")
          cellData.cell.styles.fillColor = [255, 255, 255];
      },
      theme: "grid",
    });

    // if (download) {
    //   doc.save(filename);
    // } else {
    //   window.open(URL.createObjectURL(doc.output("blob")));
    // }

    const base64PDF = doc.output("datauristring").split(",")[1];

    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          type: "download_pdf",
          fileName: filename,
          base64: base64PDF,
        }),
      );
    }
  } catch (err) {
    console.error("Rate Chart PDF generation error:", err);
  } finally {
    onFinish?.();
  }
}
